import { CommonMessage } from '@frontend/lang';
import { User } from '@frontend/user/utils';
import { LuCircleAlert, LuNfc } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { DetailCard } from '../../../components/detail-card.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useResetBadge } from './reset-badge.controller';

const ID = 'reset-badge';

const ResetBadge = () => {
    const viewProps = useResetBadge();
    const userName = viewProps.linkedUser ? new User(viewProps.linkedUser).getDisplayName() : null;

    if (!viewProps.badgeLinked) {
        return (
            <WizardScreenContainer
                id={ID}
                footer={{
                    onBack: viewProps.onBack
                }}
                containerClassName='bg-background-default flex flex-1 flex-col items-center justify-center gap-4 self-stretch p-6'>
                <LuCircleAlert className='text-danger size-16' />
                <div className='text-always-black text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.reset-badge.not-linked-title'
                        defaultMessage='Badge not linked'
                    />
                </div>
                <div className='text-foreground-secondary text-center text-sm'>
                    <FormattedMessage
                        id='kiosk.wizard.reset-badge.not-linked'
                        defaultMessage='This badge is not linked to a user.'
                    />
                </div>
            </WizardScreenContainer>
        );
    }

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{ show: viewProps.isResetting || viewProps.isResolvingLinkedUser }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.DEFAULT,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onConfirmReset,
                submitDisabled: viewProps.isResetting,
                submitLabel: CommonMessage.BUTTONS.CONFIRM
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-6 self-stretch overflow-y-scroll p-6'>
            <div className='inline-flex items-center justify-center gap-3 self-stretch'>
                <LuNfc className='text-always-black size-6' />
                <div className='text-always-black text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.reset-badge.confirm-heading'
                        defaultMessage='Are you sure you want to reset this badge?'
                    />
                </div>
            </div>

            {userName && (
                <DetailCard>
                    <DetailCard.Row
                        label={CommonMessage.OBJECTS.USER.DEFAULT}
                        value={userName}
                    />
                </DetailCard>
            )}

            <div className='text-foreground-secondary text-center text-sm'>
                <FormattedMessage
                    id='kiosk.wizard.reset-badge.warning'
                    defaultMessage='This will unlink the badge from the user.'
                />
            </div>
        </WizardScreenContainer>
    );
};

export default ResetBadge;
